import Vue from 'vue';

// main.js includes global styles, polyfills, shared scripts, i18n, and
// component initialization
import '@/base/global-js/main.js';

// js utilities that need direct access to the DOM
import '@/base/global-js/LanguageSwitcher';

// Component dependencies
import EbirdHeaderFooter from '../ebird-header-footer/EbirdHeaderFooter.vue';
import EbirdHeaderFooterTweaks from '../ebird-header-footer/EbirdHeaderFooterTweaks.vue';

import ObsMedia from '../shared/ObsMedia.vue';
Vue.component('ObsMedia', ObsMedia);

import CloSkipTo from '@/base/CloSkipTo/CloSkipTo';
Vue.component('CloSkipTo', CloSkipTo);

import CloButton from '@/base/CloButton/CloButton';
Vue.component('CloButton', CloButton);

import CloDialog from '@/base/CloDialog/CloDialog';
Vue.component('CloDialog', CloDialog);

import CloHeader from '@/navigation/CloHeader/CloHeader.vue';
Vue.component('CloHeader', CloHeader);

import CloFooter from '@/navigation/CloFooter/CloFooter.vue';
Vue.component('CloFooter', CloFooter);

// component initialization, dialogs, exotic dialog, lazy loading components
import '../shared/sharedLichen.js';